import React, { useState, useEffect } from 'react';

const EnrollCTASection = ({ onOpenPaymentPage, price = 2975 }) => {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 5,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else {
          // Reset timer when it reaches 0
          minutes = 5;
          seconds = 0;
        }
        
        return { minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (num) => num.toString().padStart(2, '0');
  const formatPrice = (num) => '₹' + Number(num).toLocaleString('en-IN');

  return (
    <section className="relative py-8 bg-gradient-to-b from-gray-900 via-black to-gray-900 overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[200px] bg-amber-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4">
        {/* Timer */}
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="flex items-center gap-2">
            <div className="relative">
              <div className="absolute inset-0 bg-red-500 rounded-lg blur-sm opacity-40"></div>
              <div className="relative bg-gradient-to-br from-red-500 to-red-700 text-white w-12 h-12 rounded-lg flex items-center justify-center text-xl font-black shadow-lg border border-red-400/30">
                {formatTime(timeLeft.minutes)}
              </div>
            </div>
            <span className="text-2xl font-black text-amber-500 animate-pulse">:</span>
            <div className="relative">
              <div className="absolute inset-0 bg-red-500 rounded-lg blur-sm opacity-40"></div>
              <div className="relative bg-gradient-to-br from-red-500 to-red-700 text-white w-12 h-12 rounded-lg flex items-center justify-center text-xl font-black shadow-lg border border-red-400/30">
                {formatTime(timeLeft.seconds)}
              </div>
            </div>
          </div>
          <p className="text-gray-400 text-sm ml-2">
            <span className="text-red-400 font-semibold">Offer expires soon!</span>
          </p>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center">
          <button 
            onClick={() => onOpenPaymentPage(price)}
            className="group relative inline-flex items-center justify-center py-4 px-10 text-lg font-bold text-black bg-gradient-to-r from-amber-400 via-yellow-400 to-orange-500 rounded-full shadow-lg shadow-amber-500/30 overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-amber-500/50"
          >
            <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>
            <span className="relative flex items-center gap-2">
              Enroll Now – {formatPrice(price)}
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default EnrollCTASection;
